import { cn } from "@/lib/utils";

export default function WantedMissmatchCode() {
  return (
    <div
      className={cn(
        "violation-group-bar",
        "absolute top-1/2 z-10 pointer-events-none -translate-y-1/2 left-[2px] border-3 rounded-sm bg-red-400/30 border-red-500",
        "animate-in fade-in duration-300 size-7.5"
      )}
      style={{
        willChange: "opacity, transform",
      }}
    >
      <div className="absolute -right-[6px] rounded-full -top-[6px] size-2 bg-red-500" />
    </div>
  );
}
